import type { IconData } from '@stacksjs/iconify-core'

export const flagAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M64 16v480h32V360h352v-37.238L363.841 208L448 93.238V56H96V16Zm348.159 72l-88 120l88 120H96V88Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default flagAlt
